import { Amplify } from "aws-amplify";
import { get, put } from "aws-amplify/api";
import { fetchAuthSession } from "aws-amplify/auth";

const awsconfig = {
  aws_project_region: "us-west-1",
};

Amplify.configure(awsconfig); // <=== Initialize Amplify with the exports config
const existingConfig = Amplify.getConfig(); // <=== the initialized config should now be returned to existingConfig

Amplify.configure({
  ...existingConfig, // <=== existingConfig instead of awsconfig
  API: {
    ...existingConfig.API,
    REST: {
      ...existingConfig.API?.REST,
      igniteinsights: {
        endpoint: "https://j5dk657cyb.execute-api.us-west-1.amazonaws.com/dev",
        region: "us-west-1",
      },
    },
  },
});

export async function getRobotData(teamNumber = "") {
  const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();
  try {
    const restOperation = get({
      apiName: "igniteinsights",
      path: `/robot_data?team_number=${teamNumber}`,
      options: {
        headers: {
          Authorization: authToken,
        },
      },
    });
    const response = await restOperation.response;
    const json = await response.body.json();
    return json;
  } catch (e) {
    console.log(e);
  }
}

export async function getAllRobotsData() {
  const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();
  try {
    console.log("Fetching all robot data...");

    const restOperation = get({
      apiName: "igniteinsights",
      path: "/robot_data",
      options: {
        headers: {
          Authorization: authToken,
        },
      },
    });

    const response = await restOperation.response;
    console.log("Response status:", response.status);
    console.log("Response headers:", response.headers);

    const text = await response.body.text();
    console.log("Response body as text:", text);

    if (!text) {
      throw new Error("Empty response body");
    }

    const json = JSON.parse(text);
    console.log("Parsed JSON:", json);
    return json;
  } catch (e) {
    console.error("Error fetching all robots:", e);
  }
}

export async function getRefData() {
  const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();
  try {
    const restOperation = get({
      apiName: "igniteinsights",
      path: `/refdata`,
      options: {
        headers: {
          Authorization: authToken,
        },
      },
    });
    const response = await restOperation.response;
    const json = await response.body.json();
    return json;
  } catch (e) {
    console.log(e);
  }
}

export async function createRobotData(body) {
  const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();
  try {
    const restOperation = put({
      apiName: "igniteinsights",
      path: `/robot_data`,
      options: {
        headers: {
          Authorization: authToken,
        },
        body: {
          body,
        },
      },
    });
    const response = await restOperation.response;
    return response;
  } catch (e) {
    console.log(e);
  }
}
